import styled from "styled-components";

export const JiraTasksWrapper = styled.div`
  grid-column: span 2;
  display: grid;
  grid-template-rows: auto auto 1fr;
  gap: 10px;
  padding: 10px;
  overflow: hidden; 
  font-size: 14px;

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`;


export const FiltersContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  grid-column: span 2;
`;

export const FilterGroup = styled.div`
  flex: 1;
  font-size: 14px;

  label {
    display: block;
    margin-top: 0.5rem;
    font-weight: 500;
  }

input {
  padding: 10px; 
  font-size: 14px; 
  border: 1px solid #ccc; 
  border-radius: 4px; 
  outline: none; 
  box-sizing: border-box; 
  width: 100%; 
}

input:focus {
  border-color: #007bff; 
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5); 
}

input::placeholder {
  color: #aaa; /* Kolor tekstu w placeholderze */
}
`;

export const CheckboxGroup = styled.div`
  margin-bottom: 1rem;
  display: flex;
  gap: 20px;
  font-size: 14px;
  grid-column: span 3;
  width: 100%;

  label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-weight: 400;
  }

  input[type="checkbox"] {
    transform: scale(1.1);
    cursor: pointer;
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;
